module.exports = __webpack_public_path__ + "img/tudelftflame.4facfad5.png";